export default {
  path: 'mall',
  meta: {
    title: '自营商城'
  },
  name: 'mall',
  component: () => import('@/components/parent-view'),
  children: [
    {
      path: 'store',
      meta: {
        title: '店铺信息'
      },
      name: 'mall-store',
      component: () => import('@/view/v5/store/index')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/v5/mall.js